import { createDuck } from 'helpers/duckTools';

export const locationDuck = createDuck('APP_LOCATION', {});

export const reducer = locationDuck;
